(function () {
    'use strict';

    angular
        .module('franchisee-portal.services')
        .service('FileService', FileService)

    /** @ngInject */
    function FileService(HttpService) {
        const FileService = {
            formatSize: formatSize,
            getResumed: getResumed,
            getAllByParameters: getAllByParameters,
            verifyDownload: verifyDownload,
            postAccessLog: postAccessLog
        }

        return FileService;

        function formatSize(bytes, decimals) {
            if (bytes == 0)
                return '0 Byte';

            var k = 1000;
            var dm = decimals + 1 || 3;
            var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
            var i = Math.floor(Math.log(bytes) / Math.log(k));

            return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
        }

        function getResumed() {
            return HttpService.get('/files/resumed');
        }

        function getAllByParameters(params) {
            return HttpService.get('/files', {
                params
            });
        }

        function verifyDownload(fileId) {
            return HttpService.get(`/files/verify/${fileId}`);
        }

        function postAccessLog(accessLogData) {
            return HttpService.post('/files/access-log', accessLogData);
        }
    }
}());